import React from "react";
import QRCodeGenerator from "./QR";

function App() {
  return <QRCodeGenerator />;
}

export default App;